import { useTheme } from "@mui/material";
import { useCallback, useContext, useEffect, useState } from "react";

import UpgradeApplicationWindow from "@/components/electron/UpgradeApplicationWindow.tsx";
import SimpleModal from "@/components/SimpleModal.tsx";
import { useGlobalFlags } from "@/hooks/useGlobalFlags";
import { UserContext } from "@/models/StateProviders/userProvider.tsx";
import { ipcRendererCallback, ipcRendererSend, isVersionGreater, removeIpcListener } from "@/utils";

type UpdatesAvailable = { available: boolean; version: string };

export default function AutoUpdateApplicationCheck({}) {
  const { disallowElectronUpgrade } = useGlobalFlags();
  const { appVersion } = useContext(UserContext);
  const [showUpgradeWindow, setShowUpgradeWindow] = useState<boolean>(false);
  const [noCloseValue, setNoCloseValue] = useState<boolean>(false);
  const [updatesAvailable, setUpdatesAvailable] = useState<UpdatesAvailable | null>(null);
  const updateAvailableCallback = useCallback(
    (_: any, value: UpdatesAvailable) => {
      setShowUpgradeWindow(() => true);
      return setUpdatesAvailable(value);
    },
    [setUpdatesAvailable, setShowUpgradeWindow],
  );

  useEffect(() => {
    ipcRendererCallback("update-available", updateAvailableCallback);
    ipcRendererSend("check-for-updates");
    return () => {
      removeIpcListener("update-available", updateAvailableCallback);
    };
  }, [updateAvailableCallback]);

  const newVersionGreater = !disallowElectronUpgrade && isVersionGreater(updatesAvailable?.version, appVersion);

  return (
    <SimpleModal
      disableClose={noCloseValue}
      closeModal={() => setShowUpgradeWindow(() => false)}
      open={newVersionGreater && showUpgradeWindow}
      sx={{ maxWidth: "330px" }}
      title="Upgrade Application"
    >
      <UpgradeApplicationWindow setNoClose={(value: boolean) => setNoCloseValue(() => value)} />
    </SimpleModal>
  );
}
